/**
 * Store Initialization Module
 *
 * This module imports all Zustand stores to ensure they are registered
 * with the centralized store reset utility. Import this module once
 * at application startup to initialize the store registry.
 */

// Import all stores to trigger their registration with storeResetUtils
import useAttendanceStore from './Employee/AttendanceStore';
import useDailyPlanStore from './Employee/DailyPlanStore';
import useEmployeeDashboardStore from './Employee/EmployeeDashboardStore';
import useEmployeeLeaveStore from './Employee/EmployeeLeaveStore';
import useAdminStore from './Admin/AdminStore';
import useMonthlySalaryStore from './hr/MonthlySalaryStore';
import usePlanBoardStore from './hr/PlanBoardStore';
import usePlanReportStore from './hr/PlanReportStore';
import useOrganizationFeedStore from './OrganizationFeedStore';
import { useOrgAdminStore } from './orgAdminStore';

// Import utility functions for external use
import {
  resetAllStores,
  getRegisteredStoreCount,
  getRegisteredStoreNames,
  handleSessionTransition,
  hasSessionConflict,
  getLastActiveUserId,
  setActiveUserId,
  clearSessionTracking
} from './storeResetUtils';

/**
 * Initialize all stores and their reset registrations.
 * Call this function once at app startup.
 */
export const initializeStores = (): void => {
  // Accessing the stores ensures they are loaded and registered
  // This is a no-op that triggers the module loading
  const storeCount = getRegisteredStoreCount();
  const storeNames = getRegisteredStoreNames();

  console.log(`Store registry initialized with ${storeCount} stores:`, storeNames);
};

// Re-export stores for convenience
export {
  useAttendanceStore,
  useDailyPlanStore,
  useEmployeeDashboardStore,
  useEmployeeLeaveStore,
  useAdminStore,
  useMonthlySalaryStore,
  usePlanBoardStore,
  usePlanReportStore,
  useOrganizationFeedStore,
  useOrgAdminStore
};

// Re-export utility functions
export {
  resetAllStores,
  getRegisteredStoreCount,
  getRegisteredStoreNames,
  handleSessionTransition,
  hasSessionConflict,
  getLastActiveUserId,
  setActiveUserId,
  clearSessionTracking
};
